/* eslint-disable react/no-array-index-key */
import React from 'react';
import useStore from 'state/state';
import { useSpring, animated } from 'react-spring';
import CloseIcon from 'assets/images/icons/close-40x40.svg';
import ScrollHint from 'assets/images/icons/scroll-hint.svg';
import Hero from './Hero/Hero';
import Footer from './Footer/Footer';
import DynamicComponent from './DynamicComponent/DynamicComponent';
import styles from './About.module.scss';

const About = () => {
  const setIsAboutOpen = useStore((state) => state.setIsAboutOpen);
  const props = useSpring({ to: { opacity: 1 }, from: { opacity: 0 } });

  const close = () => {
    setIsAboutOpen(false);
  };

  //  app data
  const appData = useStore((state) => state.appData);
  const { aboutUs } = appData.mainData;

  return (
    <animated.div style={props}>
      <div className={styles.wrapper}>
        <button
          type="button"
          className={styles.tint}
          label="tint"
          onClick={close}
        />
        <div className={styles.content}>
          <button
            label="close"
            type="button"
            onClick={close}
            className={styles.close}
          >
            <CloseIcon />
          </button>
          <aside className={styles.scrollHint}>
            <ScrollHint />
            <p className={styles.scrollaText}>
              {appData.mainData.overallApp.scrollDownText}
            </p>
          </aside>
          {aboutUs && aboutUs.hero && (
            <Hero
              overLineText={aboutUs.hero.overLineText}
              headerText={aboutUs.hero.headerText}
              ingressText={aboutUs.hero.ingressText}
              imageUrl={aboutUs.hero.imageUrl}
              links={aboutUs.hero.links}
            />
          )}

          {aboutUs &&
            aboutUs.content &&
            aboutUs.content.map((subContent, index) => (
              <DynamicComponent
                content={subContent}
                key={`${index}-${subContent.type}`}
              />
            ))}
          {appData && appData.mainData && (
            <Footer
              phoneNumber={appData.mainData.contactInfo.phoneNumber}
              email={appData.mainData.contactInfo.email}
              address={appData.mainData.contactInfo.address}
            />
          )}
        </div>
      </div>
    </animated.div>
  );
};

export default About;
